var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyGemVaultBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8333 1.66663H9.16666C5.63082 1.66663 3.86332 1.66663 2.76499 2.76496C1.66666 3.86329 1.66666 5.63163 1.66666 9.16663C1.66666 12.7016 1.66666 14.47 2.76499 15.5683C3.86332 16.6666 5.63166 16.6666 9.16666 16.6666H10.8333C14.3692 16.6666 16.1367 16.6666 17.235 15.5683C18.3333 14.47 18.3333 12.7016 18.3333 9.16663C18.3333 5.63163 18.3333 3.86329 17.235 2.76496C16.1367 1.66663 14.3683 1.66663 10.8333 1.66663Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1667 12.4999C15 12.0583 15 11.3458 15 9.92159V8.41159C15 6.98742 15 6.27492 14.1667 5.83325M15 18.3333V16.6666M5 18.3333V16.6666M7.91667 10.8333C8.13663 10.8343 8.35466 10.7921 8.5583 10.7089C8.76194 10.6258 8.9472 10.5033 9.10352 10.3486C9.25983 10.1938 9.38413 10.0098 9.46931 9.80695C9.5545 9.60415 9.59891 9.38655 9.6 9.16659C9.6 8.24575 8.84667 7.49992 7.91667 7.49992M7.91667 10.8333C7.6967 10.8343 7.47867 10.7921 7.27503 10.7089C7.07139 10.6258 6.88613 10.5033 6.72982 10.3486C6.5735 10.1938 6.44921 10.0098 6.36402 9.80695C6.27883 9.60415 6.23442 9.38655 6.23333 9.16659C6.23333 8.24575 6.98667 7.49992 7.91667 7.49992M7.91667 10.8333V12.4999M7.91667 7.49992V5.83325M6.45833 9.99992L5 10.8333M10.8333 7.49992L9.375 8.33325M9.375 9.99992L10.8333 10.8333M5 7.49992L6.45833 8.33325",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyGemVaultBold);
export default __webpack_public_path__ + "static/media/my-gem-vault-bold.100104b18b5128f187294ba8f1eae07e.svg";
export { ForwardRef as ReactComponent };